import { Button } from '@repo/ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AlertCircle, CheckCircle2, X } from 'lucide-react'
import { useEffect } from 'react'
import { toast } from 'sonner'

type RdMarketingCallbackSearch = {
  rd_oauth?: 'success' | 'error'
  reason?: string
}

export const Route = createFileRoute('/_app/integracoes/rd-marketing/callback')(
  {
    validateSearch: (
      search: Record<string, unknown>
    ): RdMarketingCallbackSearch => ({
      rd_oauth:
        search.rd_oauth === 'success' || search.rd_oauth === 'error'
          ? search.rd_oauth
          : undefined,
      reason: typeof search.reason === 'string' ? search.reason : undefined,
    }),
    component: RdMarketingCallbackPage,
  }
)

function closePopup() {
  window.close()
}

function RdMarketingCallbackPage() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  const status = search.rd_oauth === 'error' ? 'error' : 'success'
  const isSuccess = status === 'success'

  useEffect(() => {
    const payload = {
      type: 'rd-station-oauth',
      status,
      reason: search.reason ?? null,
    }

    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin)
    }

    if (isSuccess) {
      toast.success('RD Station conectado')
    } else {
      toast.error('Falha ao conectar RD Station')
    }

    window.setTimeout(closePopup, 300)
    window.setTimeout(closePopup, 900)
    window.setTimeout(closePopup, 1800)
  }, [isSuccess, search.reason, status])

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="bg-card w-full max-w-md rounded-xl border p-6 text-center shadow-sm">
        <div className="bg-muted mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full">
          {isSuccess ? (
            <CheckCircle2 className="text-success h-5 w-5" />
          ) : (
            <AlertCircle className="text-destructive h-5 w-5" />
          )}
        </div>
        <h1 className="text-lg font-semibold">
          {isSuccess ? 'RD Station conectado' : 'Falha na conexão'}
        </h1>
        <p className="text-muted-foreground mt-2 text-sm">
          {isSuccess
            ? 'A autorização foi concluída. Você já pode fechar esta janela.'
            : 'Não foi possível concluir a autorização do RD Station.'}
        </p>
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          <Button type="button" onClick={closePopup}>
            <X className="h-4 w-4" />
            Fechar janela
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => void navigate({ to: '/integracoes/rd-marketing' })}
          >
            Voltar para integração
          </Button>
        </div>
      </div>
    </div>
  )
}
